var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeditationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 8.89C9.20002 8.98 9.20002 9.05 9.21002 9.13C9.15002 9.07 9.09002 9.02 9.03002 8.97C8.14002 8.24 7.13002 7.71 6.07002 7.42C6.02002 6.2 6.27002 5.01 6.74002 3.91C7.89002 4.23 8.97002 4.8 9.89002 5.6C9.45002 6.6 9.21002 7.71 9.21002 8.88L9.20002 8.89Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.82 8.89C14.82 11.35 13.72 13.57 12 15.05C10.34 13.61 9.26995 11.5 9.20995 9.14C9.19995 9.05 9.19995 8.98 9.19995 8.9C9.19995 7.73 9.43995 6.62 9.87995 5.62C10.37 4.5 11.1 3.52 12 2.74C13.72 4.22 14.82 6.43 14.82 8.9V8.89Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.05C9.76997 15.44 7.36997 14.88 5.45997 13.32C3.55997 11.76 2.52997 9.53 2.46997 7.25C3.64997 7.04 4.87997 7.1 6.04997 7.43C7.10997 7.72 8.11997 8.25 9.00997 8.98C9.06997 9.03 9.12997 9.08 9.18997 9.14C9.24997 11.51 10.32 13.61 11.98 15.05H12Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 8.89C14.8 8.98 14.8 9.05 14.79 9.13C14.85 9.07 14.91 9.02 14.97 8.97C15.86 8.24 16.87 7.71 17.93 7.42C17.98 6.2 17.73 5.01 17.26 3.91C16.11 4.23 15.03 4.8 14.11 5.6C14.55 6.6 14.79 7.71 14.79 8.88L14.8 8.89Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.05C14.23 15.44 16.63 14.88 18.54 13.32C20.44 11.76 21.47 9.53 21.53 7.25C20.35 7.04 19.12 7.1 17.95 7.43C16.89 7.72 15.88 8.25 14.99 8.98C14.93 9.03 14.87 9.08 14.81 9.14C14.75 11.51 13.68 13.61 12.02 15.05H12Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9701 15.17H7.04006C6.49882 15.17 6.06006 15.6088 6.06006 16.15V17.24C6.06006 17.7812 6.49882 18.22 7.04006 18.22H16.9701C17.5113 18.22 17.9501 17.7812 17.9501 17.24V16.15C17.9501 15.6088 17.5113 15.17 16.9701 15.17Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.49 18.22H4.49996C3.99185 18.22 3.57996 18.6319 3.57996 19.14V20.35C3.57996 20.8581 3.99185 21.27 4.49996 21.27H19.49C19.9981 21.27 20.41 20.8581 20.41 20.35V19.14C20.41 18.6319 19.9981 18.22 19.49 18.22Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditationIcon);
export default __webpack_public_path__ + "static/media/meditation_icon.45933c81c7db94758e5ee5d4bf81c72c.svg";
export { ForwardRef as ReactComponent };